import React from 'react';
import { formatDuration } from '../../utils/formatTime';
import { useTranslation } from '../../i18n';

const LapsTableSwimming = ({ laps = [] }) => {
  const { t } = useTranslation();
  let cumulativeTime = 0;
  const formatSpeed = (speed) => (speed ? (speed * 3.6).toFixed(1) : '-');
  const total = { duration: 0, distance: 0, calories: 0, strokes: 0, avgHR: 0, maxHR: 0, avgSpeed: 0, maxSpeed: 0, cadence: 0 };

  laps.forEach((lap) => {
    total.duration  += lap.total_timer_time || 0;
    total.distance  += lap.total_distance   || 0;
    total.calories  += lap.total_calories   || 0;
    total.strokes   += lap.total_strokes    || lap.total_cycles || 0;
    total.avgHR     += lap.avg_heart_rate   || 0;
    total.maxHR     += lap.max_heart_rate   || 0;
    total.avgSpeed  += lap.enhanced_avg_speed || 0;
    total.maxSpeed  += lap.enhanced_max_speed || 0;
    total.cadence   += lap.avg_cadence      || 0;
  });

  const lapCount = laps.length || 1;
  const avg = {
    avgHR:    (total.avgHR   / lapCount).toFixed(0),
    maxHR:    (total.maxHR   / lapCount).toFixed(0),
    avgSpeed: (total.avgSpeed * 3.6 / lapCount).toFixed(1),
    maxSpeed: (total.maxSpeed * 3.6 / lapCount).toFixed(1),
    cadence:  (total.cadence / lapCount).toFixed(0),
  };

  return (
    <div className="dashboard-container">
      <div className="header" style={{ textAlign: 'center', marginTop: '2rem' }}>
        <h2 style={{ fontSize: 14, fontWeight: 700, color: '#193255' }}>{t('swimming.lapsTitle')}</h2>
      </div>

      <div style={{ overflowX: 'auto', marginTop: '2rem' }}>
        <table className="laps-table">
          <thead>
            <tr>
              <th>{t('swimming.lap')}</th>
              <th>{t('swimming.duration')}</th>
              <th>{t('swimming.accumulatedTime')}</th>
              <th>{t('swimming.distanceM')}</th>
              <th>{t('swimming.avgHRShort')}</th>
              <th>{t('swimming.maxHRShort')}</th>
              <th>{t('swimming.avgSpeedKmh')}</th>
              <th>{t('swimming.maxSpeedKmh')}</th>
              <th>{t('swimming.avgCadence')}</th>
              <th>{t('swimming.caloriesField')}</th>
              <th>{t('swimming.strokes')}</th>
            </tr>
          </thead>
          <tbody>
            {laps.map((lap, index) => {
              cumulativeTime += lap.total_timer_time || 0;
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{formatDuration(Math.round(lap.total_timer_time))}</td>
                  <td>{formatDuration(Math.round(cumulativeTime))}</td>
                  <td>{lap.total_distance?.toFixed(0) ?? '-'}</td>
                  <td>{lap.avg_heart_rate ?? '-'}</td>
                  <td>{lap.max_heart_rate ?? '-'}</td>
                  <td>{formatSpeed(lap.enhanced_avg_speed)}</td>
                  <td>{formatSpeed(lap.enhanced_max_speed)}</td>
                  <td>{lap.avg_cadence ?? '-'}</td>
                  <td>{lap.total_calories ?? '-'}</td>
                  <td>{lap.total_strokes ?? lap.total_cycles ?? '-'}</td>
                </tr>
              );
            })}
            <tr className="totals-row" style={{ backgroundColor: '#e3f2fd', fontWeight: 'bold' }}>
              <td>{t('swimming.total')}</td>
              <td>{formatDuration(Math.round(total.duration))}</td>
              <td>--</td>
              <td>{total.distance.toFixed(0)}</td>
              <td>{avg.avgHR}</td>
              <td>{avg.maxHR}</td>
              <td>{avg.avgSpeed}</td>
              <td>{avg.maxSpeed}</td>
              <td>{avg.cadence}</td>
              <td>{total.calories}</td>
              <td>{total.strokes}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LapsTableSwimming;
